import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0.339092 11.2495C0.13117 11.4328 -3.19263e-07 11.7011 -3.06196e-07 12C-3.01795e-07 12.1007 0.014877 12.1979 0.0425546 12.2895C0.0884473 12.4434 0.172147 12.5884 0.293668 12.71L6.29 18.712C6.68052 19.1026 7.31948 19.1026 7.71 18.7121C8.10053 18.3215 8.10047 17.6826 7.70995 17.292L3.41378 13L23 13C23.5523 13 24 12.5523 24 12C24 11.4477 23.5523 11 23 11L3.41872 11L7.70997 6.71287C8.10049 6.32235 8.1005 5.68339 7.70998 5.29287C7.31946 4.90234 6.6805 4.9024 6.28997 5.29292L0.339092 11.2495Z"
  }));
});
var NavigationArrowBack = AbstractIcon.withComponent(Icon);
NavigationArrowBack.displayName = 'NavigationArrowBack';
export default NavigationArrowBack;